import React from 'react';
import { useRmaItemController } from 'utils/hooks';

import { Modal } from 'components/Modal';

const RemoveItemModal = ({ onClose, item, ...props }) => {
  const { removeItem } = useRmaItemController();

  return (
    <Modal
      title="Remove Item"
      content="Are you sure you want to remove the item from this RMA Case?"
      confirmButtonText="REMOVE"
      onConfirmation={(e) => {
        removeItem(item.serialNumber);
        onClose(e);
      }}
      onDismiss={onClose}
      onCancel={onClose}
      onBackdropClick={onClose}
      {...props}
    />
  );
};

export { RemoveItemModal };
